const ADD_COURSE_EDITOR_SUCCESS = 'ADD_COURSE_EDITOR_SUCCESS';
const REMOVE_COURSE_EDITOR_SUCCESS = 'REMOVE_COURSE_EDITOR_SUCCESS';
const REQUEST_COURSE_EDITORS = 'REQUEST_COURSE_EDITORS';
const REQUEST_COURSE_EDITORS_FAIL = 'REQUEST_COURSE_EDITORS_FAIL';
const REQUEST_COURSE_EDITORS_SUCCESS = 'REQUEST_COURSE_EDITORS_SUCCESS';

export {
  ADD_COURSE_EDITOR_SUCCESS,
  REMOVE_COURSE_EDITOR_SUCCESS,
  REQUEST_COURSE_EDITORS,
  REQUEST_COURSE_EDITORS_FAIL,
  REQUEST_COURSE_EDITORS_SUCCESS,
};
